import { Link } from "react-router-dom";
import { Flame, HeartHandshake, Trophy, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/pages/HowItWorks";

const VALUES = [
  { title: "Consistency", desc: "We believe showing up beats intensity. FitLynk is built to make consistency effortless.", Icon: Flame },
  { title: "Connection", desc: "Nobody should chase goals alone. Real people keeping real people accountable.", Icon: HeartHandshake },
  { title: "Progress", desc: "Every check-in, every streak, every rep — progress you can see and celebrate.", Icon: Trophy },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero eyebrow="About FitLynk" title="A Stronger You, Together" subtitle="FitLynk connects people through fitness and sports — because the journey is better with someone in your corner." />
      <section className="py-16 md:py-24">
        <div className="px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
          <p className="text-lg text-zinc-300 leading-relaxed">
            FitLynk exists to solve the hardest part of fitness: staying consistent. We pair Members who want to stay on track with Accountability Partners who motivate, support and keep them going. One community, every sport, united by progress.
          </p>
          <div className="mt-14 grid sm:grid-cols-3 gap-6">
            {VALUES.map(({ title, desc, Icon }) => (
              <div key={title} className="rounded-2xl border border-zinc-800 bg-zinc-900/60 p-7">
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#E53E3E]/10 text-[#E53E3E]"><Icon className="w-6 h-6" /></span>
                <h3 className="mt-5 font-display text-xl font-bold uppercase tracking-tight">{title}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-14 text-center">
            <Link to="/get-started">
              <Button size="lg" className="bg-[#E53E3E] hover:bg-[#C53030] rounded-full font-semibold h-14 px-8">Join the Community <ArrowRight className="w-5 h-5 ml-2" /></Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
